// null (not 0) means "nothing remembered yet" - lets a plain page reload fall
// back to the browser's own scroll restoration instead of being forced to 0.
let homeScrollY: number | null = null;

export const saveHomeScrollY = (value: number) => {
    homeScrollY = value;
};

export const getHomeScrollY = () => homeScrollY;
